import {useLocale} from "i18n";
import type {SiteLocale} from "seo/siteMeta";
import {useMountedHostname} from "utils/useMountedHostname";
import {supportAddressFor} from "./supportAddress";

/**
 * The support inbox for the storefront this page is being served from (ui#2261).
 *
 * A thin adapter, by mandate (epic #26): the rule is {@link supportAddressFor}, React-free and unit
 * tested on its own, and {@link useMountedHostname} and the locale context supply the inputs it cannot
 * take for itself, with the hydration gate that makes taking them safe. The pre-mount pass runs the SAME
 * rule with `""` and no subfolder, which answers the fallback market's inbox, so there is no second code
 * path to keep in step.
 *
 * @param fallbackLocale passed through to {@link supportAddressFor}. `ContactBody` sets it to its
 *   document's locale, both on the pre-rendered `/contact` page and in the Resources dialog's contact
 *   panel; the support and withdrawal dialogs leave the default.
 */
export function useSupportAddress(fallbackLocale?: SiteLocale): string {
	const {storefrontSubfolder} = useLocale();
	return supportAddressFor(useMountedHostname(), storefrontSubfolder, fallbackLocale);
}
